module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/customer/customer-10-157b1f36db694c074de330b91e72f92e.jpg";